(() => {
  const dialog = document.getElementById('CookkuQuickAdd');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const image = dialog.querySelector('[data-quick-add-image]');
  const title = dialog.querySelector('[data-quick-add-title]');
  const price = dialog.querySelector('[data-quick-add-price]');
  const compare = dialog.querySelector('[data-quick-add-compare]');
  const save = dialog.querySelector('[data-quick-add-save]');
  const variants = dialog.querySelector('[data-quick-add-variants]');
  const variantId = dialog.querySelector('[data-quick-add-variant-id]');
  const quantity = dialog.querySelector('[name="quantity"]');
  const submit = dialog.querySelector('[type="submit"]');
  const submitLabel = dialog.querySelector('[data-quick-add-submit-label]');
  const error = dialog.querySelector('[data-quick-add-error]');
  const details = dialog.querySelector('[data-quick-add-details]');
  const cache = new Map();
  const currency = window.Shopify?.currency?.active || 'USD';
  const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency });
  let opener = null;
  let requestId = 0;

  const money = cents => formatter.format(cents / 100);
  const showError = message => { error.textContent = message; error.hidden = !message; };
  const close = () => { if (dialog.open) dialog.close(); };

  const setPrice = variant => {
    price.textContent = money(variant.price);
    const onSale = variant.compare_at_price > variant.price;
    compare.hidden = !onSale;
    save.hidden = !onSale;
    compare.textContent = onSale ? money(variant.compare_at_price) : '';
    save.textContent = onSale ? `Save ${Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)}%` : '';
  };

  const choose = (variant, button) => {
    variants.querySelectorAll('.cookku-quick-add__variant').forEach(option => {
      option.setAttribute('aria-pressed', String(option === button));
      option.classList.toggle('is-active-group', option.dataset.group === variant.option1);
    });
    variants.querySelectorAll('.cookku-quick-add__group').forEach(group => {
      group.setAttribute('aria-pressed', String(group.dataset.group === variant.option1));
    });
    variantId.value = variant.id;
    submit.disabled = false;
    submitLabel.textContent = 'Add to Cart';
    showError('');
    setPrice(variant);
  };

  const render = product => {
    title.textContent = product.title;
    image.src = product.featured_image || product.images?.[0] || '';
    image.alt = product.title;
    image.hidden = !image.src;
    const available = product.variants.filter(variant => variant.available);
    variants.replaceChildren();
    variants.classList.remove('has-groups');

    const optionGroups = [...new Set(product.variants.map(variant => variant.option1).filter(Boolean))];
    const grouped = optionGroups.length > 1 && optionGroups.length <= 4 && product.variants.every(variant => variant.option2 && !variant.option3);
    const optionsList = document.createElement('div');
    optionsList.className = 'cookku-quick-add__options';
    const buttons = new Map();

    product.variants.forEach(variant => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cookku-quick-add__variant';
      button.dataset.group = variant.option1 || '';
      const fullLabel = variant.public_title || variant.title;
      button.setAttribute('aria-label', fullLabel);
      const desktopLabel = document.createElement('span');
      desktopLabel.className = 'cookku-quick-add__variant-full';
      desktopLabel.textContent = fullLabel;
      const mobileLabel = document.createElement('span');
      mobileLabel.className = 'cookku-quick-add__variant-size';
      mobileLabel.textContent = variant.option2 || fullLabel;
      button.append(desktopLabel, mobileLabel);
      button.disabled = !variant.available;
      button.setAttribute('aria-pressed', 'false');
      button.addEventListener('click', () => choose(variant, button));
      optionsList.append(button);
      buttons.set(variant.id, button);
    });

    if (grouped) {
      variants.classList.add('has-groups');
      const groupTabs = document.createElement('div');
      groupTabs.className = 'cookku-quick-add__groups';
      groupTabs.setAttribute('role', 'group');
      const firstOption = product.options?.[0];
      groupTabs.setAttribute('aria-label', typeof firstOption === 'string' ? firstOption : firstOption?.name || 'Product type');
      optionGroups.forEach(groupName => {
        const groupButton = document.createElement('button');
        groupButton.type = 'button';
        groupButton.className = 'cookku-quick-add__group';
        groupButton.dataset.group = groupName;
        groupButton.textContent = groupName;
        groupButton.disabled = !available.some(variant => variant.option1 === groupName);
        groupButton.setAttribute('aria-pressed', 'false');
        groupButton.addEventListener('click', () => {
          const nextVariant = available.find(variant => variant.option1 === groupName);
          if (nextVariant) choose(nextVariant, buttons.get(nextVariant.id));
        });
        groupTabs.append(groupButton);
      });
      variants.append(groupTabs);
    }
    variants.append(optionsList);
    if (available.length) choose(available[0], buttons.get(available[0].id));
    else price.textContent = 'Sold out';
  };

  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-cookku-quick-add]');
    if (!trigger) return;
    event.preventDefault();
    opener = trigger;
    const currentRequest = ++requestId;
    const url = new URL(trigger.href, window.location.href);
    details.href = url.href;
    title.textContent = 'Loading options…';
    price.textContent = '';
    compare.hidden = true;
    save.hidden = true;
    image.hidden = true;
    variants.replaceChildren();
    variants.classList.remove('has-groups');
    variantId.value = '';
    quantity.value = 1;
    submit.disabled = true;
    submitLabel.textContent = 'Choose an option';
    showError('');
    dialog.showModal();
    try {
      url.search = '';
      url.pathname = `${url.pathname.replace(/\/$/, '')}.js`;
      if (!cache.has(url.href)) cache.set(url.href, fetch(url, { credentials: 'same-origin' }).then(response => {
        if (!response.ok) throw new Error('Could not load product options');
        return response.json();
      }));
      const product = await cache.get(url.href);
      if (currentRequest === requestId && dialog.open) render(product);
    } catch (err) {
      cache.delete(url.href);
      if (currentRequest === requestId) {
        close();
        window.location.assign(details.href);
      }
    }
  });

  dialog.querySelector('[data-quick-add-close]').addEventListener('click', close);
  dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
  dialog.addEventListener('close', () => { requestId++; opener?.focus(); });
  dialog.querySelector('[data-quick-add-decrease]').addEventListener('click', () => { quantity.value = Math.max(1, (parseInt(quantity.value, 10) || 1) - 1); });
  dialog.querySelector('[data-quick-add-increase]').addEventListener('click', () => { quantity.value = (parseInt(quantity.value, 10) || 0) + 1; });
  dialog.querySelector('form').addEventListener('submit', event => {
    if (!variantId.value || !quantity.validity.valid) {
      event.preventDefault();
      showError('Please choose an option and enter a valid quantity.');
    }
  });
  dialog.addEventListener('cookku:card-added', () => { opener = null; close(); });
  dialog.addEventListener('cookku:card-add-error', event => showError(event.detail?.message || 'Could not add this item. Please try again.'));
})();
